var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "v-expansion-panels",
        [
          _vm._l(_vm.$options.entityList, function (entity, idx) {
            return [
              _vm.$props[entity.value] && _vm.$props[entity.value].length
                ? _c(
                    "v-expansion-panel",
                    { key: idx + entity.value },
                    [
                      _c("v-expansion-panel-header", [
                        _vm._v(
                          " " +
                            _vm._s(entity.title) +
                            "(" +
                            _vm._s(_vm.$props[entity.value].length) +
                            ") "
                        ),
                      ]),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-list",
                            _vm._l(_vm.$props[entity.value], function (ent) {
                              return _c(
                                "v-list-item",
                                { key: ent.id },
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: _vm.returnLink(ent) } },
                                    [_vm._v(_vm._s(_vm.getContentTitle(ent)))]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }